const Realtypes = {
    place: 'place',
    line: 'line',
    process: 'process',
    sector: 'sector'
  };
  
  export default Realtypes;
  